import { makeActionCreator } from '../../helpers';
import { ModalsActionTypes } from '../types';

const openProjectCreated = makeActionCreator(ModalsActionTypes.openProjectCreated, ['data']);
const closeProjectCreated = makeActionCreator(ModalsActionTypes.closeProjectCreated);

const openUnsuitableWriter = makeActionCreator(ModalsActionTypes.openUnsuitableWriter);
const closeUnsuitableWriter = makeActionCreator(ModalsActionTypes.closeUnsuitableWriter);

const openExistingUser = makeActionCreator(ModalsActionTypes.openExistingUser);
const closeExistingUser = makeActionCreator(ModalsActionTypes.closeExistingUser);

const openUnableToUpdateRole = makeActionCreator(ModalsActionTypes.openUnableToUpdateRole);
const closeUnableToUpdateRole = makeActionCreator(ModalsActionTypes.closeUnableToUpdateRole);

const openThankYouForApprovingDraft = makeActionCreator(ModalsActionTypes.openThankYouForApprovingDraft);
const closeThankYouForApprovingDraft = makeActionCreator(ModalsActionTypes.closeThankYouForApprovingDraft);

const openWriterConfirmedOnProject = makeActionCreator(ModalsActionTypes.openWriterConfirmedOnProject, ['data']);
const closeWriterConfirmedOnProject = makeActionCreator(ModalsActionTypes.closeWriterConfirmedOnProject);

const openSendToPrinterModal = makeActionCreator(ModalsActionTypes.openSendToPrinterModal);
const closeSendToPrinterModal = makeActionCreator(ModalsActionTypes.closeSendToPrinterModal);

const openSuccessfullySentToPrinterModal = makeActionCreator(ModalsActionTypes.openSuccessfullySentToPrinterModal);
const closeSuccessfullySentToPrinterModal = makeActionCreator(ModalsActionTypes.closeSuccessfullySentToPrinterModal);

const openScheduleInterviewModal = makeActionCreator(ModalsActionTypes.openScheduleInterviewModal);
const closeScheduleInterviewModal = makeActionCreator(ModalsActionTypes.closeScheduleInterviewModal);

const openEditorFeedbackToWriterModal = makeActionCreator(ModalsActionTypes.openEditorFeedbackToWriterModal);
const closeEditorFeedbackToWriterModal = makeActionCreator(ModalsActionTypes.closeEditorFeedbackToWriterModal);

const openDraftIsUpdatedByWriterModal = makeActionCreator(ModalsActionTypes.openDraftIsUpdatedByWriterModal);
const closeDraftIsUpdatedByWriterModal = makeActionCreator(ModalsActionTypes.closeDraftIsUpdatedByWriterModal);

const openDraftEditedByCustomerModal = makeActionCreator(ModalsActionTypes.openDraftEditedByCustomerModal);
const closeDraftEditedByCustomerModal = makeActionCreator(ModalsActionTypes.closeDraftEditedByCustomerModal);

const openCompleteInterviewModal = makeActionCreator(ModalsActionTypes.openCompleteInterviewModal);
const closeCompleteInterviewModal = makeActionCreator(ModalsActionTypes.closeCompleteInterviewModal);

const openCancelInterviewModal = makeActionCreator(ModalsActionTypes.openCancelInterviewModal);
const closeCancelInterviewModal = makeActionCreator(ModalsActionTypes.closeCancelInterviewModal);

const openConfirmInterviewModal = makeActionCreator(ModalsActionTypes.openConfirmInterviewModal);
const closeConfirmInterviewModal = makeActionCreator(ModalsActionTypes.closeConfirmInterviewModal);

const openEditInterviewNoteModal = makeActionCreator(ModalsActionTypes.openEditInterviewNoteModal);
const closeEditInterviewNoteModal = makeActionCreator(ModalsActionTypes.closeEditInterviewNoteModal);

const openCustomerOutlineOnboardingModal = makeActionCreator(ModalsActionTypes.openCustomerOutlineOnboardingModal);
const closeCustomerOutlineOnboardingModal = makeActionCreator(ModalsActionTypes.closeCustomerOutlineOnboardingModal);

const openOutlineSubmittedModal = makeActionCreator(ModalsActionTypes.openOutlineSubmittedModal);
const closeOutlineSubmittedModal = makeActionCreator(ModalsActionTypes.closeOutlineSubmittedModal);

const openThankYouForApprovingOutlineModal = makeActionCreator(ModalsActionTypes.openThankYouForApprovingOutlineModal);
const closeThankYouForApprovingOutlineModal = makeActionCreator(ModalsActionTypes.closeThankYouForApprovingOutlineModal);

const openProofApprovedByCustomerModal = makeActionCreator(ModalsActionTypes.openProofApprovedByCustomerModal);
const closeProofApprovedByCustomerModal = makeActionCreator(ModalsActionTypes.closeProofApprovedByCustomerModal);

const openProofApprovedByEditorModal = makeActionCreator(ModalsActionTypes.openProofApprovedByEditorModal);
const closeProofApprovedByEditorModal = makeActionCreator(ModalsActionTypes.closeProofApprovedByEditorModal);

const openRedirectToRateWriterModal = makeActionCreator(ModalsActionTypes.openRedirectToRateWriterModal);
const closeRedirectToRateWriterModal = makeActionCreator(ModalsActionTypes.closeRedirectToRateWriterModal);

const openRateUserModal = makeActionCreator(ModalsActionTypes.openRateUserModal);
const closeRateUserModal = makeActionCreator(ModalsActionTypes.closeRateUserModal);

const openFirstInterviewScheduledModal = makeActionCreator(ModalsActionTypes.openFirstInterviewScheduledModal);
const closeFirstInterviewScheduledModal = makeActionCreator(ModalsActionTypes.closeFirstInterviewScheduledModal);

const openOnboardingModal = makeActionCreator(ModalsActionTypes.openOnboardingModal);
const closeOnboardingModal = makeActionCreator(ModalsActionTypes.closeOnboardingModal);

const openDraftApprovedByCustomerModal = makeActionCreator(ModalsActionTypes.openDraftApprovedByCustomerModal);
const closeDraftApprovedByCustomerModal = makeActionCreator(ModalsActionTypes.closeDraftApprovedByCustomerModal);

const openDraftApprovedByWriterModal = makeActionCreator(ModalsActionTypes.openDraftApprovedByWriterModal);
const closeDraftApprovedByWriterModal = makeActionCreator(ModalsActionTypes.closeDraftApprovedByWriterModal);

const openDraftApprovedByEditorModal = makeActionCreator(ModalsActionTypes.openDraftApprovedByEditorModal);
const closeDraftApprovedByEditorModal = makeActionCreator(ModalsActionTypes.closeDraftApprovedByEditorModal);

const openRateOutlineModal = makeActionCreator(ModalsActionTypes.openRateOutlineModal);
const closeRateOutlineModal = makeActionCreator(ModalsActionTypes.closeRateOutlineModal);

const openRateBookOutlineModal = makeActionCreator(ModalsActionTypes.openRateBookOutlineModal);
const closeRateBookOutlineModal = makeActionCreator(ModalsActionTypes.closeRateBookOutlineModal);

const openRateDraftModal = makeActionCreator(ModalsActionTypes.openRateDraftModal);
const closeRateDraftModal = makeActionCreator(ModalsActionTypes.closeRateDraftModal);

const openDeleteCoverPhotosModal = makeActionCreator(ModalsActionTypes.openDeleteCoverPhotosModal);
const closeDeleteCoverPhotosModal = makeActionCreator(ModalsActionTypes.closeDeleteCoverPhotosModal);

const openUseTimelineModal = makeActionCreator(ModalsActionTypes.openUseTimelineModal);
const closeUseTimelineModal = makeActionCreator(ModalsActionTypes.closeUseTimelineModal);

const openCoverNotificationModal = makeActionCreator(ModalsActionTypes.openCoverNotificationModal);
const closeCoverNotificationModal = makeActionCreator(ModalsActionTypes.closeCoverNotificationModal);

const openHubspotModal = makeActionCreator(ModalsActionTypes.openHubspotModal);
const closeHubspotModal = makeActionCreator(ModalsActionTypes.closeHubspotModal);

const openUpgradeRequestedModal = makeActionCreator(ModalsActionTypes.openUpgradeRequestedModal);
const closeUpgradeRequestedModal = makeActionCreator(ModalsActionTypes.closeUpgradeRequestedModal);

const openPackageUpgradeRequestModal = makeActionCreator(ModalsActionTypes.openPackageUpgradeRequestModal);
const closePackageUpgradeRequestModal = makeActionCreator(ModalsActionTypes.closePackageUpgradeRequestModal);

const openUpgradeRequestCompletedModal = makeActionCreator(ModalsActionTypes.openUpgradeRequestCompletedModal);
const closeUpgradeRequestCompletedModal = makeActionCreator(ModalsActionTypes.closeUpgradeRequestCompletedModal);

const openQuestionnaireSentModal = makeActionCreator(ModalsActionTypes.openQuestionnaireSentModal);
const closeQuestionnaireSentModal = makeActionCreator(ModalsActionTypes.closeQuestionnaireSentModal);

const openRateWriterByDevelopmentalEditorModal = makeActionCreator(ModalsActionTypes.openRateWriterByDevelopmentalEditorModal);
const closeRateWriterByDevelopmentalEditorModal = makeActionCreator(ModalsActionTypes.closeRateWriterByDevelopmentalEditorModal);

const openRateProofByCustomerModal = makeActionCreator(ModalsActionTypes.openRateProofByCustomerModal);
const closeRateProofByCustomerModal = makeActionCreator(ModalsActionTypes.closeRateProofByCustomerModal);

const openOnboardingFeedbackModal = makeActionCreator(ModalsActionTypes.openOnboardingFeedbackModal);
const closeOnboardingFeedbackModal = makeActionCreator(ModalsActionTypes.closeOnboardingFeedbackModal);

const openConfirmSampleApprovalModal = makeActionCreator(ModalsActionTypes.openConfirmSampleApprovalModal);
const closeConfirmSampleApprovalModal = makeActionCreator(ModalsActionTypes.closeConfirmSampleApprovalModal);

const openThankYouForApprovingSampleModal = makeActionCreator(ModalsActionTypes.openThankYouForApprovingSampleModal);
const closeThankYouForApprovingSampleModal = makeActionCreator(ModalsActionTypes.closeThankYouForApprovingSampleModal);

const openChatBotInfoModal = makeActionCreator(ModalsActionTypes.openChatBotInfoModal);
const closeChatBotInfoModal = makeActionCreator(ModalsActionTypes.closeChatBotInfoModal);

const openThankYouForStyleSampleApprovalModal = makeActionCreator(
  ModalsActionTypes.openThankYouForStyleSampleApprovalModal,
);
const closeThankYouForStyleSampleApprovalModal = makeActionCreator(
  ModalsActionTypes.closeThankYouForStyleSampleApprovalModal,
);

const openExtensionFeePaymentModal = makeActionCreator(ModalsActionTypes.openExtensionFeePaymentModal);
const closeExtensionFeePaymentModal = makeActionCreator(ModalsActionTypes.closeExtensionFeePaymentModal);

const openCustomerAccessToProjectBlockedModal = makeActionCreator(
  ModalsActionTypes.openCustomerAccessToProjectBlockedModal,
);
const closeCustomerAccessToProjectBlockedModal = makeActionCreator(
  ModalsActionTypes.closeCustomerAccessToProjectBlockedModal,
);

const openActiveSubscriptionWarnModal = makeActionCreator(ModalsActionTypes.openActiveSubscriptionWarnModal);
const closeActiveSubscriptionWarnModal = makeActionCreator(ModalsActionTypes.closeActiveSubscriptionWarnModal);

const openAccessToProjectBlockedModal = makeActionCreator(ModalsActionTypes.openAccessToProjectBlockedModal);
const closeAccessToProjectBlockedModal = makeActionCreator(ModalsActionTypes.closeAccessToProjectBlockedModal);

const openRateByWriterModal = makeActionCreator(ModalsActionTypes.openRateByWriterModal);
const closeRateByWriterModal = makeActionCreator(ModalsActionTypes.closeRateByWriterModal);

const openTranscribeAudioFileModal = makeActionCreator(ModalsActionTypes.openTranscribeAudioFileModal);
const closeTranscribeAudioFileModal = makeActionCreator(ModalsActionTypes.closeTranscribeAudioFileModal);

const openRestoreVersionModal = makeActionCreator(ModalsActionTypes.openRestoreVersionModal);
const closeRestoreVersionModal = makeActionCreator(ModalsActionTypes.closeRestoreVersionModal);

const openEditorProofNotReadyModal = makeActionCreator(ModalsActionTypes.openEditorProofNotReadyModal);
const closeEditorProofNotReadyModal = makeActionCreator(ModalsActionTypes.closeEditorProofNotReadyModal);

const openNoAddressForCustomerModal = makeActionCreator(ModalsActionTypes.openNoAddressForCustomerModal);
const closeNoAddressForCustomerModal = makeActionCreator(ModalsActionTypes.closeNoAddressForCustomerModal);

const openRequestReviewModal = makeActionCreator(ModalsActionTypes.openRequestReviewModal);
const closeRequestReviewModal = makeActionCreator(ModalsActionTypes.closeRequestReviewModal);

export default {
  openProjectCreated,
  closeProjectCreated,
  openUnsuitableWriter,
  closeUnsuitableWriter,
  openExistingUser,
  closeExistingUser,
  openUnableToUpdateRole,
  closeUnableToUpdateRole,
  openThankYouForApprovingDraft,
  closeThankYouForApprovingDraft,
  openWriterConfirmedOnProject,
  closeWriterConfirmedOnProject,
  openSendToPrinterModal,
  closeSendToPrinterModal,
  openSuccessfullySentToPrinterModal,
  closeSuccessfullySentToPrinterModal,
  openScheduleInterviewModal,
  closeScheduleInterviewModal,
  openEditorFeedbackToWriterModal,
  closeEditorFeedbackToWriterModal,
  openDraftIsUpdatedByWriterModal,
  closeDraftIsUpdatedByWriterModal,
  openDraftEditedByCustomerModal,
  closeDraftEditedByCustomerModal,
  openCompleteInterviewModal,
  closeCompleteInterviewModal,
  openCancelInterviewModal,
  closeCancelInterviewModal,
  openConfirmInterviewModal,
  closeConfirmInterviewModal,
  openEditInterviewNoteModal,
  closeEditInterviewNoteModal,
  openCustomerOutlineOnboardingModal,
  closeCustomerOutlineOnboardingModal,
  openOutlineSubmittedModal,
  closeOutlineSubmittedModal,
  openThankYouForApprovingOutlineModal,
  closeThankYouForApprovingOutlineModal,
  openProofApprovedByCustomerModal,
  closeProofApprovedByCustomerModal,
  openProofApprovedByEditorModal,
  closeProofApprovedByEditorModal,
  openRedirectToRateWriterModal,
  closeRedirectToRateWriterModal,
  openRateUserModal,
  closeRateUserModal,
  openFirstInterviewScheduledModal,
  closeFirstInterviewScheduledModal,
  openOnboardingModal,
  closeOnboardingModal,
  openDraftApprovedByCustomerModal,
  closeDraftApprovedByCustomerModal,
  openDraftApprovedByWriterModal,
  closeDraftApprovedByWriterModal,
  openDraftApprovedByEditorModal,
  closeDraftApprovedByEditorModal,
  openRateDraftModal,
  closeRateDraftModal,
  openDeleteCoverPhotosModal,
  closeDeleteCoverPhotosModal,
  openUseTimelineModal,
  closeUseTimelineModal,
  openCoverNotificationModal,
  closeCoverNotificationModal,
  openHubspotModal,
  closeHubspotModal,
  openUpgradeRequestedModal,
  closeUpgradeRequestedModal,
  openPackageUpgradeRequestModal,
  closePackageUpgradeRequestModal,
  openUpgradeRequestCompletedModal,
  closeUpgradeRequestCompletedModal,
  openQuestionnaireSentModal,
  closeQuestionnaireSentModal,
  openRateWriterByDevelopmentalEditorModal,
  closeRateWriterByDevelopmentalEditorModal,
  openRateProofByCustomerModal,
  closeRateProofByCustomerModal,
  openOnboardingFeedbackModal,
  closeOnboardingFeedbackModal,
  openConfirmSampleApprovalModal,
  closeConfirmSampleApprovalModal,
  openThankYouForApprovingSampleModal,
  closeThankYouForApprovingSampleModal,
  openRateOutlineModal,
  closeRateOutlineModal,
  openRateBookOutlineModal,
  closeRateBookOutlineModal,
  openChatBotInfoModal,
  closeChatBotInfoModal,
  openThankYouForStyleSampleApprovalModal,
  closeThankYouForStyleSampleApprovalModal,
  openExtensionFeePaymentModal,
  closeExtensionFeePaymentModal,
  openCustomerAccessToProjectBlockedModal,
  closeCustomerAccessToProjectBlockedModal,
  openActiveSubscriptionWarnModal,
  closeActiveSubscriptionWarnModal,
  openAccessToProjectBlockedModal,
  closeAccessToProjectBlockedModal,
  openRateByWriterModal,
  closeRateByWriterModal,
  openTranscribeAudioFileModal,
  closeTranscribeAudioFileModal,
  openRestoreVersionModal,
  closeRestoreVersionModal,
  openEditorProofNotReadyModal,
  closeEditorProofNotReadyModal,
  openNoAddressForCustomerModal,
  closeNoAddressForCustomerModal,
  openRequestReviewModal,
  closeRequestReviewModal,
};
